<template>
  <v-container id="inscripcion-ivt">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  dark
                  color="success"
                  class="alineacentro DatosMatriculado"
                >
                  <strong>INSCRIPCIÓN A CARRERA</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="permitealtaerror.length>0">
              <v-col cols="12">
                <p class="textoNegritaRojo">{{permitealtaerror}}</p>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar"
                  @click="Listar('')"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Nueva Inscripción"
                  @click="Nueva"
                  :disabled="!permisoescritura || !permitealta"
                >
                  <v-icon dark> mdi-plus</v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Confirmar Todas las Inscripciones Activas"
                  @click="ConfirmarTodo"
                  v-if="roles.includes(3) || roles.includes(4)"
                  :disabled="!permisoescritura || (!roles.includes(3) && !roles.includes(4)) || listainscripciones.length===0"
                >
                  <v-icon dark> mdi-check-all</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="!roles.includes(1) && !roles.includes(100)">
              <v-col cols="12" md="8" lg="8">
                <v-select
                  v-model="filtros.idcarrera"
                  :items="listacarrerasfiltro"
                  label="Carrera"
                  item-text="carrera"
                  item-value="idcarrera"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  v-model="filtros.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="anio"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <v-text-field
                        v-model="filtroinscripcion"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-card-title>
                    <v-data-table
                    :headers="columnasinsc"
                    :items="listainscripciones"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idinscripcion"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                    :search="filtroinscripcion"
                    >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="Editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.permitiredicion===false"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="AnularInscripcion(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.permitiranular===false"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Anular Inscripción</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom v-if="roles.includes(3) || roles.includes(99)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="ConfirmarInscribir(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.permitircambiotipo===false"
                          >
                            mdi-check-bold
                          </v-icon>
                        </template>
                        <span>Confirmar Inscripción</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="ImprimirComprobante(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-printer
                          </v-icon>
                        </template>
                        <span>Imprimir Comprobante de Inscripción</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialognuevo" fullscreen>
      <v-card>
        <v-card-title class="headline">
          {{ dialognuevotitulo }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="Guardar">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialognuevo = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12" md="1" lg="1">
              <v-spacer />
            </v-col>
            <v-col cols="12" md="10" lg="10">
              LOS DATOS INGRESADOS EN EL FORMULARIO DE INSCRIPCIÓN TIENEN
              CARÁCTER DE <strong>DECLARACIÓN JURADA</strong> Y SERÁN
              CONSTATADOs OPORTUNAMENTE POR LA INSTITUCIÓN.
            </v-col>
            <v-col cols="12" md="1" lg="1">
              <v-spacer />
            </v-col>
          </v-row>
          <v-row class="alineaizquierda">
            <v-col cols="12">
              <strong>Para continuar complete los siguientes datos:</strong>
            </v-col>
          </v-row>
          <v-row class="alineaizquierda">
            <v-col cols="12">
              <v-divider />
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12">
              <v-card class="alineacentro DatosMatriculado">
                <v-card-text>
                  <v-tabs
                    centered
                    color="#4bc47f"
                    dark
                    icons-and-text
                    v-model="tabactivo"
                  >
                    <v-tabs-slider color="#2a6bbf" />
                    <v-tab href="#tab-1" key="Datos">
                      Datos del Inscripto
                      <v-icon>mdi-account</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-1">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idtipodoc"
                                :items="listatiposdocumentos"
                                label="Tipo Doc."
                                item-text="nombre"
                                item-value="idtipodoc"
                                height="20px"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                            <v-col cols="12" md="5" lg="5">
                              <v-text-field
                                v-model="edited.nrodoc"
                                label="N° Documento"
                                height="20px"
                                v-on:keyup.enter="BuscarAlumno"
                                :rules="ReglaRequerido"
                                v-if="roles.includes(3) || roles.includes(4)"
                              />
                              <v-text-field
                                v-model="edited.nrodoc"
                                label="N° Documento"
                                height="20px"
                                :rules="ReglaRequerido"
                                v-if="!roles.includes(3) && !roles.includes(4)"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                            <v-col cols="12" md="1" lg="1">
                                <v-btn
                                  class="ma-2"
                                  dark
                                  x-small
                                  color="primary"
                                  title="Buscar Alumno"
                                  @click="BuscarAlumno"
                                  v-if="roles.includes(3) || roles.includes(4)"
                                >
                                  <v-icon dark> mdi-magnify </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col v-if="alumnobuscado && noexistealumno" cols="12" md="3" lg="3">
                              <strong class="letraroja">El alumno no existe, ingrese todos los datos del mismo</strong>
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12">
                              <v-select
                                v-model="edited.idcohorte"
                                :items="listacarreras"
                                label="Carrera a Inscribirse"
                                item-text="cohortecompleta"
                                item-value="idcohorte"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12" md="6" lg="6">
                              <v-text-field
                                v-model="edited.apellido"
                                label="Apellidos"
                                height="20px"
                                :rules="ReglaRequerido"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                            <v-col cols="12" md="6" lg="6">
                              <v-text-field
                                v-model="edited.nombre"
                                label="Nombres"
                                height="20px"
                                :rules="ReglaRequerido"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12" md="3" lg="3">
                              <v-menu
                                v-model="menufecnac"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="fechalocalfecnac"
                                    label="Fecha Nacim."
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    height="20px"
                                    readonly
                                    :rules="ReglaRequerido"
                                    :disabled="nodebemodificar"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="edited.fechanac"
                                  @input="menufecnac = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idsexo"
                                :items="listasexos"
                                label="Sexo"
                                item-text="nombre"
                                item-value="idsexo"
                                height="20px"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-text-field
                                v-model="edited.nacionalidad"
                                label="Nacionalidad"
                                height="20px"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idestadocivil"
                                :items="listaestadosciviles"
                                label="Est. Civil"
                                item-text="nombre"
                                item-value="idestadocivil"
                                height="20px"
                                :disabled="nodebemodificar"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12" md="6" lg="6">
                              <selector-localidad
                                titulo="Localidad de Nacimiento"
                                ref="sellocnac"
                                :idinicial="edited.idlocalidadnac"
                                @selLocalidad="asignalocalidadnacimiento"
                                :disabled="nodebemodificar"
                              ></selector-localidad>
                            </v-col>
                            <v-col cols="12" md="5" lg="5">
                              <v-text-field
                                v-model="edited.domicilio"
                                label="Domicilio"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="1" lg="1">
                              <v-text-field
                                v-model="edited.codpostal"
                                label="CP"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12" md="4" lg="4">
                              <selector-localidad
                                titulo="Localidad de Residencia"
                                ref="sellocres"
                                :idinicial="edited.idlocalidadres"
                                @selLocalidad="asignalocalidadresidencia"
                              ></selector-localidad>
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-text-field
                                v-model="edited.telefono"
                                label="Tel. Fijo"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-text-field
                                v-model="edited.celular"
                                label="Celular"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.emailpersonal"
                                label="Email"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-2" key="Responsables" v-if="edited.idcohorte>0 && listacarreras.filter(c=> c.idcohorte===edited.idcohorte)[0].idnivel<4">
                      Responsables
                      <v-icon>mdi-account</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-2" v-if="edited.idcohorte>0 && listacarreras.filter(c=> c.idcohorte===edited.idcohorte)[0].idnivel<4">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nuevo Responsable"
                                @click="NuevoResponsable"
                                :disabled="!permisoescritura || nodebemodificar || editinscripcion"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasresponsables"
                                :items="edited.responsables"
                                :items-per-page="10"
                                :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                }"
                                item-key="idpersona"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        @click="QuitarResponsable(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura || nodebemodificar || editinscripcion"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    </template>
                                    <span>Quitar Responsable</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                     </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-3" key="Facturacion">
                      Datos para Facturación
                      <v-icon>mdi-account-cash</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-3">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12">
                              <v-select
                                v-model="edited.idcondicioniva"
                                :items="listacondicionesiva"
                                label="Cond. Frente a IVA"
                                item-text="nombre"
                                item-value="idcondicioniva"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.cuit"
                                label="CUIT/CUIL"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="alumnobuscado" class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.domiciliofiscal"
                                label="Domicilio Fiscal"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-4" key="Documentacion">
                      Documentación
                      <v-icon>mdi-file-document</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-4">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="AgregarDocumentacion"
                                @click="NuevaDocu"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasdocumentacion"
                                :items="documentos"
                                :items-per-page="10"
                                :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                }"
                                item-key="iddocumentacion"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Archivos pre-existentes"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        @click="QuitarArchivo(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    </template>
                                    <span>Borrar Archivo</span>
                                </v-tooltip>
                              </template>
                            </v-data-table>
                          </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogdocumentonuevo" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">
          Agregando Documento...
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="AgregarDocumento">
                Agregar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogdocumentonuevo = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row row wrap>
            <v-col cols="12" md="6" lg="6">
              <v-select
                v-model="regdocu.iddocumentacion"
                :items="listadocumentaciones"
                label="Documentacion"
                item-text="nombre"
                item-value="iddocumentacion"
                height="20px"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-file-input
                v-model="regdocu.files"
                color="deep-purple accent-4"
                counter
                label="Seleccione Archivos de Documentación para Adjuntar"
                multiple
                placeholder="Seleccione Archivos"
                prepend-icon="mdi-paperclip"
                :show-size="1000"
                height="20px"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 2"
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                  <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                    +{{ files.length - 2 }} Archivo(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                v-model="regdocu.cantidad"
                label="Cantidad"
                type="number"
                height="20px"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                v-model="regdocu.observacion"
                label="Observación"
                height="20px"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogresponsablenuevo" fullscreen>
      <v-card>
        <v-card-title class="headline">
          Agregando Responsable...
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="GrabarResponsable">
                Agregar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogresponsablenuevo = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-card-text class="titulocardchico TituloGrilla2">
                <strong>DATOS PERSONALES</strong>
              </v-card-text>
              <v-card-text>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="4" lg="4">
                    <v-select
                        v-model="editedresp.idtipodoc"
                        :items="listatiposdocumentos"
                        label="Tipo Doc."
                        item-text="nombre"
                        item-value="idtipodoc"
                        height="20px"
                        :disabled="respencontrado"
                    />
                    </v-col>
                    <v-col cols="12" md="8" lg="8">
                    <v-text-field
                        v-model="editedresp.nrodoc"
                        label="N° Documento"
                        height="20px"
                        :rules="ReglaRequerido"
                        v-on:keyup.enter="BuscarResponsable"
                        v-on:blur="BuscarResponsable"
                        :disabled="respencontrado"
                    />
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.apellido"
                        label="Apellidos"
                        height="20px"
                        :rules="ReglaRequerido"
                        :disabled="respencontrado"
                    />
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.nombre"
                        label="Nombres"
                        height="20px"
                        :rules="ReglaRequerido"
                        :disabled="respencontrado"
                    />
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="9" lg="9">
                    <v-select
                        v-model="editedresp.idtipoparentesco"
                        :items="listatiposparentescos"
                        label="Parentesco"
                        item-text="nombre"
                        item-value="idtipoparentesco"
                        height="20px"
                    />
                    </v-col>
                    <v-col cols="12" md="3" lg="3">
                    <v-select
                        v-model="editedresp.conviveconalumno"
                        :items="listaconvive"
                        label="Convive"
                        item-text="item"
                        item-value="item"
                        height="20px"
                    />
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.domicilio"
                        label="Domicilio"
                        height="20px"
                    />
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.ocupacion"
                        label="Ocupación"
                        height="20px"
                    />
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12">
                    <selector-localidad
                        titulo="Localidad"
                        ref="sellocresponsable"
                        :idinicial="editedresp.idlocalidad"
                        @selLocalidad="asignalocalidadresponsable"
                    ></selector-localidad>
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.telefono"
                        label="Teléfono"
                        height="20px"
                    />
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.celular"
                        label="Celular"
                        height="20px"
                    />
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                    <v-text-field
                        v-model="editedresp.email"
                        label="Email"
                        height="20px"
                    />
                    </v-col>
                </v-row>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-card-text class="titulocardchico TituloGrilla2">
                <strong>RESPONSABILIDADES</strong>
              </v-card-text>
              <v-card-text>
                <v-row class="alineaizquierda">
                    <v-col cols="12" md="8" lg="8">
                    <v-select
                        v-model="idresponsabilidadsel"
                        :items="listaresponsabilidades"
                        label="Responsabilidad"
                        item-text="nombre"
                        item-value="idtiporesponsabilidad"
                        height="20px"
                    />
                    </v-col>
                    <v-col cols="12" md="4" lg="4" class="alineaderecha">
                    <v-btn
                        class="ma-2"
                        x-small
                        color="blue"
                        title="Agregar"
                        @click="AgregarResponsabilidad"
                    >
                        <v-icon dark> mdi-plus</v-icon>
                    </v-btn>
                    </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                    <v-col cols="12">
                    <v-data-table
                        :headers="columnasresponsabilidades"
                        :items="editedresp.responsabilidades"
                        :items-per-page="10"
                        :footer-props="{
                            'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text': 'Todos',
                        }"
                        item-key="idresponsabilidad"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                    >
                        <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                small
                                @click="QuitarResponsabilidad(item)"
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-delete
                            </v-icon>
                            </template>
                            <span>Quitar Responsabilidad</span>
                        </v-tooltip>
                        </template>
                        <template v-slot:item.desde="{ item }">
                        {{ fechalocal(item.desde) }}
                        </template>
                        <template v-slot:item.hasta="{ item }">
                        {{ fechalocal(item.hasta) }}
                        </template>
                    </v-data-table>
                    </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="editedresp.responsabilidades.filter(r=>r.idresponsabilidad===1).length>0" class="titulocardchico TituloGrilla2">
                <strong>DATOS FISCALES</strong>
              </v-card-text>
              <v-card-text v-if="editedresp.responsabilidades.filter(r=>r.idresponsabilidad===1).length>0">
                <v-row class="alineaizquierda">
                  <v-col cols="12">
                    <v-select
                      v-model="editedresp.idcondicioniva"
                      :items="listacondicionesiva"
                      label="Cond. Frente a IVA"
                      item-text="nombre"
                      item-value="idcondicioniva"
                      height="20px"
                    />
                  </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedresp.cuit"
                      label="CUIT/CUIL"
                      height="20px"
                    />
                  </v-col>
                </v-row>
                <v-row class="alineaizquierda">
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedresp.domiciliofiscal"
                      label="Domicilio Fiscal"
                      height="20px"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorLocalidad from "../../components/SelectorLocalidad.vue";
export default {
  name: "inscripcioncarrera",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorLocalidad,
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 3,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      listainscripciones: [],
      columnasinsc: [
        {
          text: "Op.",
          value: "actions",
          width: 100
        },
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "idinscripcion",
          width: 20
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 180
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anioingreso",
          width: 30
        },
        {
          text: "Inscripto",
          align: "center",
          sortable: true,
          value: "inscripto",
          width: 180
        },
        {
          text: "DNI",
          align: "center",
          sortable: true,
          value: "dni",
          width: 80
        },
        // {
        //   text: "F. Nacim",
        //   align: "center",
        //   sortable: true,
        //   value: "fecnacstrdmy",
        //   width: 90
        // },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipoinscripcion",
          width: 100
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100
        }
      ],
      filtros: {
        anio: 0,
        idcarrera: 0
      },
      menufecnac: false,
      edited: {
        idinscripcion: 0,
        idalumno: 0,
        idcohorte: 0,
        anioingreso: 0,
        apellido: '',
        nombre: '',
        idtipodoc: 1,
        nrodoc: '',
        idsexo: 1,
        fechanac: '',
        idlocalidadnac: 0,
        domicilio: '',
        codpostal: '',
        idlocalidadres: 0,
        nacionalidad: '',
        idestadocivil: 1,
        telefono: '',
        celular: '',
        emailpersonal: '',
        idcondicioniva: 1,
        cuit: '',
        domiciliofiscal: '',
        documentacion: [
          //{iddocumentacion: 0,documentacion: '', cantidad: 0, observacion: '', urlarchivo:'', activo: true, archivo: []}
        ],
        responsables: [],
        usuario: '',
      },
      dialognuevo: false,
      dialognuevotitulo: '',
      listaanios: [],
      files: [],
      columnasdocumentacion: [
        {
          text: "Op.",
          value: "actions",
          width: 40
        },
        /* {
          text: "ID",
          align: "center",
          sortable: true,
          value: "iddocumentacion",
          width: 30
        }, */
        {
          text: "Documentación",
          align: "center",
          sortable: true,
          value: "documentacion",
          width: 150
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          value: "cantidad",
          width: 50
        },
        {
          text: "Obs.",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 120
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "activostr",
          width: 80
        }
        /* {
          text: "Archivo",
          align: "center",
          sortable: true,
          value: "urlarchivo",
          width: 120
        } */
      ],
      regdocu: {
        iddocumentacion: 1,
        files: [],
        observacion: '',
        cantidad: 0
      },
      dialogdocumentonuevo:false,
      listadocumentaciones: [],
      noexistealumno: false,
      listasexos: [],
      listaestadosciviles: [],
      listacondicionesiva: [],
      listacarreras: [],
      tabactivo: 'Datos',
      listatiposdocumentos: [],
      ReglaRequerido: [
        v => !!v || 'Requerido'
      ],
      editinscripcion: false,
      documentos: [],
      filtroinscripcion: '',
      listacarrerasfiltro: [],
      alumnobuscado: false,
      nodebemodificar: false,
      columnasresponsables: [
        {
          text: "Op.",
          value: "actions",
          width: 40
        },
        {
          text: "Documento",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 90
        },
        {
          text: "Apellido",
          align: "center",
          sortable: true,
          value: "apellido",
          width: 150
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 150
        },
        {
          text: "Parentesco",
          align: "center",
          sortable: true,
          value: "tipoparentesco",
          width: 100
        },
        {
          text: "Celular",
          align: "center",
          sortable: true,
          value: "celular",
          width: 90
        },
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email",
          width: 120
        }
      ],
      editedresp:{
        idpersona: 0,
        idtipodoc: 0,
        nrodoc: '',
        apellido: '',
        nombre: '',
        idparentesco: 0,
        conviveconalumno: '',
        ocupacion: '',
        domicilio: '',
        idlocalidad: 0,
        telefono: '',
        celular: '',
        email: '',
        idcondicioniva: 0,
        cuit: '',
        domiciliofiscal: '',
        responsabilidades: []
      },
      listatiposparentescos: [],
      listaconvive: ['SI', 'NO'],
      idresponsabilidadsel: '',
      listaresponsabilidades: [],
      columnasresponsabilidades: [
        {
          text: "Op.",
          value: "actions",
          width: 40
        },
        {
          text: "Responsabilidad",
          align: "center",
          sortable: true,
          value: "responsabilidad",
          width: 150
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desde",
          width: 90
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hasta",
          width: 90
        },
        {
          text: "Activo",
          align: "center",
          sortable: true,
          value: "activostr",
          width: 90
        }
      ],
      dialogresponsablenuevo: false,
      respencontrado: false,
      permitealta: true,
      permitealtaerror: ''
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.filtros.anio= (new Date()).getFullYear()+1;
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2023;i<=anioactual+1;i++){
          this.listaanios.push({anio: i});
        }
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        this.permitealta= true;
        this.permitealtaerror='';
        if(this.roles.includes(3) || this.roles.includes(4)) {
          var parametro= {anio: this.filtros.anio};
          axios.post("inscripcioncarrera/PostCarrerasActivas", parametro, { headers: { "Content-Type": "application/json"}}).then((result) => {
            if(result.data.resultado===0){
              this.listacarrerasfiltro = result.data.datos;
              this.filtros.idcarrera= this.listacarrerasfiltro.length>0 ? this.listacarrerasfiltro[0].idcarrera : 0;
              this.Listar('');
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }else{
            var param= {anio: 0};
            axios.post("inscripcioncarrera/PostCohortesActivas", param, { headers: { "Content-Type": "application/json" }})
              .then((result) => {
                if(result.data.resultado===0){
                    if(result.data.datos.length>0){
                      this.permitealta= true;
                      this.permitealtaerror='';
                      this.loading = false;
                    }else{
                      this.permitealta= false;
                      this.permitealtaerror='No existen inscripciones de carreras abiertas!!!';
                      this.loading = false;
                    }
                }else{
                    this.loading = false;
                    this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                }
            })
            .catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
            });
        }
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar(mensaje) {
      this.loading = true;
      var usuario= this.usuario;
      var anio= this.filtros.anio; //this.roles.includes(1) ? 0 : this.filtros.anio;
      var idcarrera= this.filtros.idcarrera;
      axios.get('inscripcioncarrera/LI/' + usuario + '/' + anio + '/' + idcarrera + '/0')
        .then((result) => {
          if(result.data.resultado===0){
            this.listainscripciones = result.data.datos;
            this.loading = false;
            if(mensaje.length>0){
                this.MostrarMensaje("Mensaje", mensaje, false);
            }
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    CompletarCombos (nueva, item) {
      axios.get("referenciales/tiposdocumentacion")
        .then((result) => {
          if(result.data.resultado===0){
            this.listadocumentaciones = result.data.datos;
            axios.get("referenciales/tiposdocumento")
              .then((result) => {
                if(result.data.resultado===0){
                  this.listatiposdocumentos = result.data.datos;
                  axios.get("referenciales/sexo")
                    .then((result) => {
                        if(result.data.resultado===0){
                        this.listasexos = result.data.datos;
                        axios.get("referenciales/estadocivil")
                            .then((result) => {
                                if(result.data.resultado===0){
                                this.listaestadosciviles = result.data.datos;
                                axios.get("referenciales/condicioniva")
                                    .then((result) => {
                                        if(result.data.resultado===0){
                                          this.listacondicionesiva = result.data.datos;
                                          var parametro= {anio: 0};
                                          axios.post("inscripcioncarrera/PostCohortesActivas", parametro, {
                                            headers: {
                                                "Content-Type": "application/json",
                                            },
                                          })
                                            .then((result) => {
                                                if(result.data.resultado===0){
                                                  this.listacarreras = result.data.datos;
                                                  axios.get("referenciales/tipoparentesco")
                                                    .then((result) => {
                                                      if(result.data.resultado===0){
                                                        this.listatiposparentescos = result.data.datos;
                                                        axios.get("referenciales/responsabilidades")
                                                          .then((result) => {
                                                            if(result.data.resultado===0) {
                                                              this.listaresponsabilidades = result.data.datos;
                                                              if(nueva===true){
                                                                this.ContinuaNueva();
                                                              }else{
                                                                this.ContinuarEdit(item);
                                                              }
                                                            }
                                                        }).catch((error) => {
                                                            this.loading = false;
                                                            this.MostrarMensaje('Error', error, false);
                                                        });
                                                      }
                                                    }).catch((error) => {
                                                        this.loading = false;
                                                        this.MostrarMensaje('Error', error, false);
                                                    });
                                                }else{
                                                  this.loading = false;
                                                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                                                }
                                            })
                                            .catch((error) => {
                                                this.loading = false;
                                                this.MostrarMensaje('Error', error, false);
                                            });
                                        }else{
                                          this.loading = false;
                                          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                                        }
                                    })
                                    .catch((error) => {
                                        this.loading = false;
                                        this.MostrarMensaje('Error', error, false);
                                    });
                                }else{
                                  this.loading = false;
                                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.MostrarMensaje('Error', error, false);
                            });
                        }else{
                          this.loading = false;
                          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.MostrarMensaje('Error', error, false);
                    });
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                }
              })
                .catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });

          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    },
    Nueva() {
      this.loading=true;
      this.tabactivo= 'Datos';
      this.editinscripcion=false;
      this.alumnobuscado=false;
      this.noexistealumno=false;
      this.CompletarCombos(true,null);
    },
    ContinuaNueva () {
      this.files = [];
      this.documentos=[];
      this.dialognuevotitulo = "Nueva Inscripción";
      if(this.roles.includes(1) || this.roles.includes(100)) {
        //this.nodebemodificar=true;
        this.TraeDatosAlumno(' ',this.usuario);
      } else {
        //this.noexistealumno=false;
        this.nodebemodificar=false;
        this.edited= {
            idinscripcion: 0,
            idalumno: 0,
            idcohorte: '',
            anioingreso: 0,
            apellido: '',
            nombre: '',
            idtipodoc: 1,
            nrodoc: '',
            idsexo: 1,
            fechanac: '',
            idlocalidadnac: 0,
            domicilio: '',
            codpostal: '',
            idlocalidadres: 0,
            nacionalidad: '',
            idestadocivil: 1,
            telefono: '',
            celular: '',
            emailpersonal: '',
            idcondicioniva: '',
            cuit: '',
            domiciliofiscal: '',
            documentacion: [
            //   {iddocumentacion: '', cantidad: 0, observacion: '', archivos:[]}
            ],
            responsables: [],
            usuario: this.usuario,
        };
        this.dialognuevo=true;
        this.loading = false;
      }
    },
    NuevaDocu () {
      this.regdocu= {
        iddocumentacion: 1,
        files: [],
        observacion: '',
        cantidad: 1
      };
      this.dialogdocumentonuevo=true;
    },
    AgregarDocumento () {
      if(this.documentos.filter(d=> d.iddocumentacion===this.regdocu.iddocumentacion && d.activo===true).length===0){
        this.documentos.push({iditemdocumentacion: 0, iddocumentacion: this.regdocu.iddocumentacion, documentacion: this.listadocumentaciones.filter(d=> d.iddocumentacion===this.regdocu.iddocumentacion)[0].nombre, cantidad: this.regdocu.cantidad, observacion: this.regdocu.observacion, files: this.regdocu.files, urlarchivo: '', activo: true, activostr: 'ACTIVO'});
        this.dialogdocumentonuevo=false;
      }else{
        this.MostrarMensaje('Documentación Repetida!','La Documentación ya esta en la lista de la inscripción actual.',false);
      }
    },
    Guardar() {
      this.loading = true;
      this.edited.anioingreso= parseInt(this.listacarreras.filter(c=> c.idcohorte===this.edited.idcohorte)[0].anioimplementa);
      this.ValidarInscripcion();
    },
    ValidarInscripcion () {
      var res='';
      //VALIDAR CONTRA BD
      if(this.edited.idcohorte===null || this.edited.idcohorte==='') {
        res='Debe seleccionar la cohorte de la carrera a la cual se inscribe';
      }
      if(this.editinscripcion===false && this.listainscripciones.filter(c=> c.dni===this.edited.nrodoc && c.idcohorte===this.edited.idcohorte && c.idestado===1).length>0) {
        res='Ya existe una inscripción activa del alumno/a para la cohorte seleccionada';
      }
      if(this.documentos.length===0) {
        res='Debe adjuntar la documentación solicitada de inscripción';
      }
      if (res.length===0){
        var param= JSON.stringify({ idinscripcion: this.edited.idinscripcion, idalumno: this.edited.idalumno, idcohorte: this.edited.idcohorte,anioingreso: this.edited.anioingreso });
        axios.post("inscripcioncarrera/PostValidaInscripcion", param, { headers: { "Content-Type": "application/json" }})
        .then((result) => {
          if (result.data.resultado === 0) {
            this.GuardaArchivos();
          } else {
            res= result.data.resultadomensaje;
            this.loading = false;
            this.MostrarMensaje('Error de Validación', res, false);
          }
        }).catch(() => {
          res= 'Error al chequear el cupo de inscripción. Consulte con IVT.';
          this.loading = false;
          this.MostrarMensaje('Error de Validación', res, false);
        });
      }else{
        this.loading = false;
        this.MostrarMensaje('Error de Validación', res, false);
      }
    },
    GuardaArchivos () {
        if (this.documentos.filter(d=> d.files.length>0).length > 0) {
          let files = new FormData();
          var i=0;
          var docarchivos=this.documentos.filter(d=> d.files.length>0);
          for (i = 0; i < docarchivos.length; i++) {
            let file = docarchivos[i].files[0];
            files.append('files', file, file.name + '|' + docarchivos[i].iddocumentacion.toString());
            //this.edited.documentacion[i].iddocumentacion.toString()
          }
          axios.post("inscripcioncarrera/PostArchivos", files, {
              headers: {
                "content-type": "multipart/form-data",
              },
            })
            .then((result) => {
              if (result.data.resultado === 0) {
                this.GuardarInscripcion(result.data.archivos);
              } else {
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
              }
            })
            .catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        } else {
          this.GuardarInscripcion(null);
        }
    },
    GuardarInscripcion(archivos) {
      if (archivos != null) {
        for (var i = 0; i < archivos.length; i++) {
          var reg = archivos[i];
          var regd=this.documentos.filter(d=> d.iddocumentacion===reg.iddocumentacion)[0]
          this.edited.documentacion.push({iditemdocumentacion: parseInt(regd.iditemdocumentacion), iddocumentacion: parseInt(reg.iddocumentacion), documentacion: regd.documentacion, cantidad: parseInt(regd.cantidad), observacion: regd.observacion!=null ? regd.observacion : '', urlarchivo: reg.url, activo: regd.activo, activostr: regd.activostr });
        }
      }
      for (var f = 0; f < this.documentos.length; f++) {
        if(this.documentos[f].activo===false) {
            var r=this.edited.documentacion.filter(d=> d.iddocumentacion===this.documentos[f].iddocumentacion)[0];
            r.activo=this.documentos[f].activo;
            r.activostr= this.documentos[f].activostr;
        }
      }
      this.edited.cuit= this.edited.cuit!=null ? this.edited.cuit.toString() : '';
      this.edited.domiciliofiscal= this.edited.domiciliofiscal!=null ? this.edited.domiciliofiscal : '';
      this.edited.idcondicioniva= this.edited.idcondicioniva!=null && this.edited.idcondicioniva!='' ? this.edited.idcondicioniva : 0;
      const insc = JSON.stringify(this.edited);
      axios.post("inscripcioncarrera/PostInscripcion", insc, { headers: { "Content-Type": "application/json" } })
        .then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            var mge= result.data.idturnotramite>0 ? 'INSCRIPCIÓN CORRECTA. LE CORRESPONDE EL TURNO PARA MATRICULARSE EN LA SIGUIENTE FECHA: ' + result.data.turnotramite : '';
            this.Listar(mge);
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    Editar(item) {
      this.loading=true;
      this.tabactivo= 'Datos';
      this.dialognuevotitulo = "Editando la inscripción N°: " + item.idinscripcion.toString();
      this.editinscripcion=true;
      this.noexistealumno=false;
      this.CompletarCombos(false,item);
    },
    ContinuarEdit (item) {
      this.alumnobuscado= true;
      this.documentos=[];
      this.edited= {
        idinscripcion: item.idinscripcion,
        idalumno: item.idalumno,
        idcohorte: item.idcohorte,
        anioingreso: item.anioingreso,
        apellido: item.apellido,
        nombre: item.nombre,
        idtipodoc: item.idtipodoc,
        nrodoc: item.dni,
        idsexo: item.idsexo,
        fechanac: item.fecnacstr,
        idlocalidadnac: item.idlocalidadnac,
        domicilio: item.domicilio,
        codpostal: item.codpostal,
        idlocalidadres: item.idlocalidad,
        nacionalidad: item.nacionalidad,
        idestadocivil: item.idestadocivil,
        telefono: item.telefono,
        celular: item.celular,
        emailpersonal: item.emailpersonal,
        idcondicioniva: item.idcondicioniva,
        cuit: item.cuit,
        domiciliofiscal: item.domiciliofiscal,
        documentacion: item.documentacion,
        usuario: this.usuario,
      };
    //   if(this.roles.includes(1) || this.roles.includes(100)) {
    //     this.nodebemodificar=true;
    //   }
      this.files = [];
      var i=0;
      for(i=0;i<this.edited.documentacion.length;i++){
        this.documentos.push({iditemdocumentacion: this.edited.documentacion[i].iditemdocumentacion, iddocumentacion: this.edited.documentacion[i].iddocumentacion, documentacion: this.edited.documentacion[i].documentacion, cantidad: this.edited.documentacion[i].cantidad, observacion: this.edited.documentacion[i].observacion, files: [], urlarchivo: this.edited.documentacion[i].urlarchivo, activo: this.edited.documentacion[i].activo, activostr: this.edited.documentacion[i].activostr});
      }
      this.loading=false;
      this.dialognuevo = true;
    },
    async AnularInscripcion(item) {
      if (await this.$refs.confirm.open("Confirmar Anulación de la Inscripción","Esta seguro de querer anular la inscripción ID " + item.idinscripcion.toString() + " ?")) {
        this.loading = true;
        var insc = { idinscripcion: item.idinscripcion, usuario: this.usuario };
        axios
          .put("inscripcioncarrera/PutAnularInscripcion", insc, {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          })
          .then((result) => {
            if (result.data.resultado === 0) {
              this.Listar('');
            } else {
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    async ConfirmarInscribir(item) {
        if (await this.$refs.confirm.open("Confirmar Inscripción","Esta seguro de querer confirmar la inscripción ID " + item.idinscripcion.toString() + " ?")) {
        this.loading = true;
        var insc = { anio: 0,idcarrera: 0, idinscripcion: item.idinscripcion, usuario: this.usuario };
        axios
          .put("inscripcioncarrera/PutConfirmarInscripcion", insc, {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          })
          .then((result) => {
            if (result.data.resultado === 0) {
              this.Listar('');
            } else {
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    ImprimirComprobante (item) {
      this.loading = true;
      axios.post("reportes/GetReporte",
          {
            idreporte: 4,
            nromodulo: this.nromodulo,
            usuario: this.usuario,
            formato: "PDF",
            listaparametros: [
              { orden: 1, nombre: "idinscripcion", valor: item.idinscripcion.toString() },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    AbrirCuadroImprimirExportar() {
      this.dialogverexportar = true;
    },
    exportar() {
      this.loading = true;
      var fecdesde =
        this.filtros.fechadesde != "" && this.filtros.fechadesde != null
          ? this.filtros.fechadesde
          : " ";
      var fechasta =
        this.filtros.fechahasta != "" && this.filtros.fechahasta != null
          ? this.filtros.fechahasta
          : " ";
      var asunto =
        this.filtros.asunto != "" && this.filtros.asunto != null
          ? this.filtros.asunto
          : " ";
      var remitente =
        this.filtros.remitente != "" && this.filtros.remitente != null
          ? this.filtros.remitente
          : " ";
      var destinatario =
        this.filtros.destinatario != "" && this.filtros.destinatario != null
          ? this.filtros.destinatario
          : " ";
      var iddelegacion =
        this.filtros.iddelegacion != "" && this.filtros.iddelegacion != null
          ? this.filtros.iddelegacion
          : "0";
      var notadesde =
        this.filtros.notadesde != "" && this.filtros.notadesde != null
          ? this.filtros.notadesde
          : "0";
      var notahasta =
        this.filtros.notahasta != "" && this.filtros.notahasta != null
          ? this.filtros.notahasta
          : "0";
      var notaacuse =
        this.filtros.notaacuse != "" && this.filtros.notaacuse != null
          ? this.filtros.notaacuse
          : "0";
      axios
        .post(
          "reportes/GetReporte",
          {
            idreporte: 27,
            formato: this.formatosel,
            nromodulo: parseInt(this.nromodulo), 
            usuario: this.usuario.toString(),
            listaparametros: [
              { orden: 1, nombre: "desde", valor: fecdesde },
              { orden: 2, nombre: "hasta", valor: fechasta },
              { orden: 3, nombre: "iddelegacion", valor: iddelegacion },
              { orden: 4, nombre: "asunto", valor: asunto },
              { orden: 5, nombre: "remitente", valor: remitente },
              { orden: 6, nombre: "destinatario", valor: destinatario },
              { orden: 7, nombre: "notadesde", valor: notadesde },
              { orden: 8, nombre: "notahasta", valor: notahasta },
              { orden: 9, nombre: "notaacuse", valor: notaacuse },
              { orden: 10, nombre: "idtiponota", valor: "1" },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    asignalocalidadnacimiento(value) {
      this.edited.idlocalidadnac = value != null ? value.idlocalidad : 0;
    },
    asignalocalidadresidencia(value) {
      this.edited.idlocalidadres = value != null ? value.idlocalidad : 0;
    },
    asignalocalidadresponsable (value) {
      this.editedresp.idlocalidad = value != null ? value.idlocalidad : 0;
    },
    async QuitarArchivo (item) {
      if (await this.$refs.confirm.open('Confirmar Anulación','Esta seguro de querer anular el archivo?')) {
        item.activo = false;
        item.activostr='BAJA';
      }
    },
    BuscarAlumno () {
      if(this.edited.nrodoc!=null && this.edited.nrodoc!=''){
        this.TraeDatosAlumno(this.edited.nrodoc,'');
      }else{
        this.MostrarMensaje('Error','Ingrese N° de Documento',false);
      }
    },
    TraeDatosAlumno (nrodoc, usuario) {
      var doc=  nrodoc!=null && nrodoc!='' ?  nrodoc : ' ';
      var user= usuario!=null && usuario.length>0 ? usuario : ' ';
      axios.get("alumno/buscapersonaalumnoinscripcion/" + doc + '/' + user + '/0')
        .then((result) => {
            if(result.data.resultado===0){
                var alu=result.data.datos;
                this.edited.usuario= this.usuario;
                this.edited.idalumno= alu.idalumno!=null ? alu.idalumno : 0;
                this.edited.apellido= alu.apellido;
                this.edited.nombre= alu.nombre;
                this.edited.idtipodoc= alu.idtipodoc!=null ? alu.idtipodoc : 1;
                this.edited.nrodoc= alu.nrodoc!=null ? alu.nrodoc : '';
                this.edited.idsexo= alu.idsexo!=null ? alu.idsexo : '';
                this.edited.fechanac= alu.fechanac!=null ? alu.fechanac : '';
                this.edited.idlocalidadnac= alu.idlocalidadnac!=null ? alu.idlocalidadnac : 0;
                this.edited.domicilio= alu.domicilio;
                this.edited.codpostal= alu.codpostal;
                this.edited.idlocalidadres= alu.idlocalidad!=null ? alu.idlocalidad : 0;
                this.edited.nacionalidad= alu.nacionalidad;
                this.edited.idestadocivil= alu.idestadocivil!=null ? alu.idestadocivil : '';
                this.edited.telefono= alu.telefono;
                this.edited.celular= alu.celular;
                this.edited.emailpersonal= alu.emailpersonal;
                this.edited.idcondicioniva= alu.idcondicioniva!=null ? alu.idcondicioniva : '';
                this.edited.cuit= alu.cuit!=null ? alu.cuit : '';
                this.edited.domiciliofiscal= alu.domiciliofiscal!=null ? alu.domiciliofiscal : '';
                this.noexistealumno=false;
                this.alumnobuscado= true;
                if(this.$refs.sellocnac!=null){
                  this.$refs.sellocnac.BuscarRegistro();
                }
                if(this.$refs.sellocres!=null){
                  this.$refs.sellocres.BuscarRegistro();
                }
                this.loading = false;
                this.dialognuevo=true;
            }else if(result.data.resultado===2){
                if(this.$refs.sellocnac!=null){
                  this.$refs.sellocnac.QuitarRegistro();
                }
                if(this.$refs.sellocres!=null){
                    this.$refs.sellocres.QuitarRegistro();
                }
                this.noexistealumno=true;
                this.alumnobuscado= true;
                if(this.dialognuevo===false){
                  this.dialognuevo=true;
                }
                this.loading = false;
            }else{
              if(this.$refs.sellocnac!=null){
                this.$refs.sellocnac.QuitarRegistro();
              }
              if(this.$refs.sellocres!=null){
                this.$refs.sellocres.QuitarRegistro();
              }
              this.noexistealumno=false;
              this.alumnobuscado= true;
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
        })
        .catch((error) => {
          if(this.$refs.sellocnac!=null){
            this.$refs.sellocnac.QuitarRegistro();
          }
          if(this.$refs.sellocres!=null){
            this.$refs.sellocres.QuitarRegistro();
          }
          this.noexistealumno=false;
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    },
    async ConfirmarTodo () {
      if (await this.$refs.confirm.open("Confirmar Inscripción","Esta seguro de querer confirmar todas las inscripciones activas del año y carrera seleccionados?")) {
        this.loading = true;
        var param = { anio: this.filtros.anio,idcarrera: this.filtros.idcarrera, idinscripcion: 0, usuario: this.usuario };
        axios
          .put("inscripcioncarrera/PutConfirmarInscripcion", param, {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          })
          .then((result) => {
            if (result.data.resultado === 0) {
              this.Listar('');
            } else {
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    NuevoResponsable () {
      this.respencontrado=false;
      var idnuevo= this.edited.responsables.length>0 ? this.edited.responsables[this.edited.responsables.length-1].id+1 : 1;
      this.editedresp= {
        id: idnuevo,
        idpersona: 0,
        idtipodoc: 0,
        nrodoc: '',
        apellido: '',
        nombre: '',
        idtipoparentesco: 0,
        conviveconalumno: 'SI',
        ocupacion: '',
        domicilio: '',
        idlocalidad: 0,
        telefono: '',
        celular: '',
        email: '',
        idcondicioniva: 0,
        cuit: '',
        domiciliofiscal: '',
        responsabilidades: []
      };
      this.dialogresponsablenuevo= true;
    },
    async QuitarResponsable (item) {
      if (await this.$refs.confirm.open('Confirmar Anulación de Responsable','Esta seguro de querer anular al responsable?')) {
        // item.activo = false;
        // item.activostr='BAJA';
        // item.activohasta= this.fechaFormatoYMD(new Date());
        this.edited.responsables.splice(this.edited.responsables.indexOf(item), 1);
      }
    },
    GrabarResponsable () {
     var validores= this.ValidarResponsable();
     if(validores==='OK'){
      this.edited.responsables.push({id: this.editedresp.id, idpersona: this.editedresp.idpersona,idtipodoc: this.editedresp.idtipodoc,nrodoc: this.editedresp.nrodoc, apellido: this.editedresp.apellido, nombre: this.editedresp.nombre, domicilio: this.editedresp.domicilio,idlocalidad: this.editedresp.idlocalidad, idtipoparentesco: this.editedresp.idtipoparentesco, tipoparentesco: this.listatiposparentescos.filter(p=> p.idtipoparentesco===this.editedresp.idtipoparentesco)[0].nombre,conviveconalumno: this.editedresp.conviveconalumno, ocupacion: this.editedresp.ocupacion, telefono: this.editedresp.telefono, celular: this.editedresp.celular, email: this.editedresp.email,idcondicioniva: this.editedresp.idcondicioniva,domiciliofiscal: this.editedresp.domiciliofiscal,cuit: this.editedresp.cuit.toString(), activo: true, activostr: 'ACTIVO', activodesde: this.fechaFormatoYMD(new Date()), activohasta: '', responsabilidades: this.editedresp.responsabilidades});
      this.dialogresponsablenuevo= false;
     }else{
      this.MostrarMensaje('Error', validores, false);
     }
    },
    ValidarResponsable () {
      var valido='OK';
      return valido;
    },
    BuscarResponsable () {
      this.loading=true;
      var doc=  this.editedresp.nrodoc!=null && this.editedresp.nrodoc!='' ?  this.editedresp.nrodoc : ' ';
      var user= this.usuario!=null && this.usuario.length>0 ? this.usuario : ' ';
      axios.get("alumno/buscaresponsable/" + doc + '/' + user + '/0')
        .then((result) => {
            if(result.data.resultado===0){
              if(result.data.datos.length>0){
                var per=result.data.datos[0];
                this.editedresp.idpersona= per.idpersona;
                this.editedresp.idtipodoc= per.idtipodoc;
                this.editedresp.apellido= per.apellido;
                this.editedresp.nombre= per.nombre;
                this.editedresp.ocupacion= per.ocupacion;
                this.editedresp.domicilio= per.domicilio;
                this.editedresp.idlocalidad= per.idlocalidad;
                this.editedresp.telefono= per.telefono;
                this.editedresp.celular= per.celular;
                this.editedresp.email= per.emailpersonal;
                this.editedresp.idcondicioniva= parseInt(per.idcondicioniva);
                this.editedresp.cuit= per.cuit;
                this.editedresp.domiciliofiscal= per.domiciliofiscal;
                if(this.$refs.sellocresponsable!=null){
                  if(per.idlocalidad!=null && per.idlocalidad!=0) {
                    this.$refs.sellocresponsable.id= per.idlocalidad;
                    this.$refs.sellocresponsable.BuscarRegistro();
                  }else{
                    this.$refs.sellocresponsable.QuitarRegistro();
                  }
                }
                this.respencontrado=true;
              }
              this.loading=false;
            }else{
              if(this.$refs.sellocresponsable!=null){
                this.$refs.sellocresponsable.QuitarRegistro();
              }
              this.loading=false;
              this.MostrarMensaje('Error', result.data.resultadomensaje,false);
            }
        })
        .catch((error) => {
          if(this.$refs.sellocresponsable!=null){
            this.$refs.sellocresponsable.QuitarRegistro();
          }
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    },
    AgregarResponsabilidad () {
      if(this.idresponsabilidadsel!=null && this.idresponsabilidadsel!=0){
        this.editedresp.responsabilidades.push({idresponsabilidad: this.idresponsabilidadsel, responsabilidad: this.listaresponsabilidades.filter(r=> r.idtiporesponsabilidad===this.idresponsabilidadsel)[0].nombre, desde: this.fechaFormatoYMD(new Date()), hasta: '', activo: true, activostr: 'ACTIVO'});
      }
    },
    QuitarResponsabilidad (item) {
    //   item.activo = false;
    //   item.activostr='BAJA';
    //   item.hasta= this.fechaFormatoYMD(new Date());
    this.editedresp.responsabilidades.splice(this.editedresp.responsabilidades.indexOf(item), 1);
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    fechalocal: function (pfecha) {
      if (pfecha != null && pfecha != "") {
        var fecha = new Date(pfecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
  computed: {
    fechalocalfecnac: function () {
      if (this.edited.fechanac != null && this.edited.fechanac != "") {
        var fecha = new Date(this.edited.fechanac);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>